import { UntypedFormGroup, ValidationErrors } from "@angular/forms";

export function organizationLocationDatesValidator(control: UntypedFormGroup): ValidationErrors | null {
    const logexActiveFrom = control.get("logex").get("activeFrom").value;
    const mrdmActiveFrom = control.get("mrdm").get("activeFrom").value;
    const officialActiveFrom = control.get("official").get("activeFrom").value;

    if (logexActiveFrom || mrdmActiveFrom || officialActiveFrom) {
        return null;
    }
    return { startDateRequired: true };
}
